module.exports = __webpack_public_path__ + "static/media/instagram.2faa7fd4.svg";